import React from 'react'
import { Route, IndexRoute } from 'react-router'
import 'normalize.css/normalize.css'
import { StyleguideFrame } from './StyleguideFrame'
import { Typography } from './sections/Typography'
import { Colors } from './sections/Colors'
import { Buttons } from './sections/Buttons'
import { Modals } from './sections/Modals'
import { Login } from './sections/Login'
import { Popovers } from './sections/Popovers'
import { Tooltips } from './sections/Tooltips'
import { Icons } from './sections/Icons'
import { Forms } from './sections/Forms'
import { Time } from './sections/Time'
import { Widgets } from './sections/Widgets'
import { Lists } from './sections/Lists'
import { NavbarSection, NavbarDemo } from './sections/NavbarSection'
import { SearchSection, SearchDemo } from './sections/SearchSection'
import { HeroComponent } from './sections/HeroComponent'
import { Units } from './sections/Units'

export const routes = <>
  <Route component={StyleguideFrame}>
    <IndexRoute component={Typography} />
    <Route path='colors' component={Colors} />
    <Route path='buttons' component={Buttons} />
    <Route path='modals' component={Modals} />
    <Route path='lists' component={Lists} />
    <Route path='hero_component' component={HeroComponent} />
    <Route path='popovers' component={Popovers} />
    <Route path='tooltips' component={Tooltips} />
    <Route path='login' component={Login} />
    <Route path='icons' component={Icons} />
    <Route path='forms' component={Forms} />
    <Route path='time' component={Time} />
    <Route path='widgets' component={Widgets} />
    <Route path='navbar' component={NavbarSection} />
    <Route path='search' component={SearchSection} />
    <Route path='units' component={Units} />
  </Route>
  <Route path='navbar_demo' component={NavbarDemo} />
  <Route path='search_demo' component={SearchDemo} />
</>
